export function ImgAddPerson({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.45 7.75C11.45 7.19772 11.8977 6.75 12.45 6.75H17.7C18.2523 6.75 18.7 7.19772 18.7 7.75C18.7 8.30228 18.2523 8.75 17.7 8.75H12.45C11.8977 8.75 11.45 8.30228 11.45 7.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 11.5C14.4477 11.5 14 11.0523 14 10.5V5.25001C14 4.69772 14.4477 4.25001 15 4.25001C15.5523 4.25001 16 4.69772 16 5.25001V10.5C16 11.0523 15.5523 11.5 15 11.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 5C6.20818 5 5.5 5.67902 5.5 6.6C5.5 7.52098 6.20818 8.2 7 8.2C7.79182 8.2 8.5 7.52098 8.5 6.6C8.5 5.67902 7.79182 5 7 5ZM3.5 6.6C3.5 4.6491 5.0304 3 7 3C8.9696 3 10.5 4.6491 10.5 6.6C10.5 8.5509 8.9696 10.2 7 10.2C5.0304 10.2 3.5 8.5509 3.5 6.6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 14.8333C1 11.538 3.78924 9.06665 7.01348 9.06665C10.2449 9.06665 13 11.5447 13 14.8333V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14.8333C11 12.7527 9.24668 11.0667 7.01348 11.0667C4.77323 11.0667 3.00022 12.7593 3 14.8329C3 14.8331 3 14.8328 3 14.8329L3.0017 16.9992C3.00214 17.5515 2.55478 17.9995 2.00249 18C1.45021 18.0004 1.00214 17.5531 1.0017 17.0008L1 14.8333Z"
      />
    </svg>
  );
}